<template>
  <button @click="open" class="btn btn-outline-gray btn-sm is-border-1">
    <i class="fa fa-info"></i> Chi tiết
    <b-modal v-model="show" size='xxl' title="Chi tiết lần chăm sóc" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <b-form-row>
        <b-col cols='6'>
          <div>
            <h6>Thông tin bệnh nhân</h6>
            <div class="alert alert-info">
              <b>Họ và tên: </b> <span>{{benhNhan.name ? benhNhan.name : 'Không rõ'}}</span><br>
              <b>Năm sinh: </b> <span>{{benhNhan.dob ? benhNhan.dob : 'Không rõ'}}</span><br>
              <b>Tuổi: </b> <span>{{benhNhan.age ? benhNhan.age : 'Không rõ'}}</span><br>
              <b>Ngày xét nghiệm: </b> <span>{{benhNhan.testDate ? benhNhan.testDate : 'Không rõ'}}</span><br>
              <b>Ngày ra khỏi BV/ khu cách ly: </b> <span>{{benhNhan.getOutOfHospitalDate ? benhNhan.tegetOutOfHospitalDatestDate : 'Không rõ'}}</span><br>
              <b>CT Value: </b> <span>{{benhNhan.ctValue ? benhNhan.ctValue : 'Không rõ'}}</span><br>
              <b>Giới tính: </b> <span>{{benhNhan.gender === 'unknown' ? 'Không rõ' : benhNhan.gender === 'male' ? 'Nam' : 'Nữ'}}</span><br>
              <b>Lý do xét nghiệm: </b> <span>{{benhNhan.testReason ? benhNhan.testReason : 'Không rõ'}}</span>
            </div>
          </div>
          <div>
            <h6>Thông tin chăm sóc</h6>
            <div class="alert alert-warning">
              <b>Nhóm NC: </b> <span>{{history.tier ? history.tier : 'Không rõ'}}</span><br>
              <b>Điểm: </b> <span>{{history.score ? history.score : 'Không rõ'}}</span><br>
              <b>Lần gọi tiếp theo: </b> <span v-if="history.nextCallTime">{{ history.nextCallTime | moment('DD/MM/YY HH:mm') }}</span><br>
              <b>Ghi chú: </b> <span>{{history.note ? history.note : 'Không có'}}</span><br>
            </div>
          </div>
        </b-col>
        <b-col cols='6'>
          <h6>Câu hỏi sàng lọc, tư vấn</h6>
          <b-form-group :disabled="true"
              v-for='(section, index) in QUESTION_LIST'
              :key='section.section_id'
              :label='`${index + 1}. ${section.text}`'
          >
            <b-form-checkbox-group
              :v-if='checkboxes != null'
              stacked
              :disabled="true"
              :id='section.section_id'
              v-model='checkboxes'
              :options='section.question_list'
              :name='section.section_id'
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-modal>
  </button>
</template>

<script>
import crud from '@/mixins/CRUD';
import QUESTION_LIST from './constants/benh-nhan-call-question-list.json';
import TIER_INFO from './constants/tier-info.json';

export default {
  components: {},
  inheritAttrs: false,
  props: ['benhNhan', 'history'],
  mixins: [crud],
  created() {
    this.QUESTION_LIST = QUESTION_LIST;
    this.TIER_INFO = TIER_INFO;
  },
  data() {
    return {
      show: false,
      formData: {},
      tierOptions() {
        return [
          { value: null, text: 'Phân loại' },
          { value: 'nc0', text: 'NC0' },
          { value: 'nc1', text: 'NC1' },
          { value: 'nc2', text: 'NC2' },
          { value: 'nc3', text: 'NC3' },
          { value: 'nc4', text: 'NC4' },
        ];
      },
    };
  },
  computed: {
    checkboxes() {
      try {
        const result = JSON.parse(this.history.formDetails[0]);
        return result;
      } catch (error) {
        return [];
      }
    }
  },
  methods: {
    open() {
      this.show = true;
      this.formData = this.history;
    },
    close() {
      this.show = false;
      this.$emit('hidden');
    }
  }
};
</script>
